module.exports = ["cryptocurr","decentr","gdpr","blockchain","ai","algorithm","5g","robot","iot","health","machin_learn","learn_algorithm","black_box","renew_energi","digit_currenc","distribut_ledger","smart_contract","autonom_weapon","fake_news","hate_speech","person_data","privaci_polici","free_speech","social_media","patent_law","wireless_sensor","open_data","neural_network"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_ssrn.json
// module id = NKmV
// module chunks = 1